import React, { FC } from 'react'
import { format } from '@dt/fe-utils'
import './couponItem.scss'

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  coupon: IDiscountItemCoupon | IDiscountCoupon;
  isDelete?: boolean;
}

const couponColor = {
  cashenable: '#E94A39',
  cashmutex: 'rgba(233,74,57, 0.5)',
  orderenable: '#E99A39',
  ordermutex: 'rgba(233,154,57, 0.5)',
  itemenable: '#1D7DFF',
  itemmutex: 'rgba(29,125,255, 0.5)'
}

const CouponItem: FC<IProps> = ({ coupon, isDelete, onClick }) => {
  return (
    <div className='coupon-item-wrapper' data-cypid={`promoCodeCouponItem_${coupon?.memberCouponId}`} onClick={onClick}>
      <div className='coupon-item-l' style={{ background: `${couponColor[`${coupon.type}${coupon.status}`]}` }}>
        <h3>
          {coupon.discountType === 'discountFee' || coupon.discountType === 'specialOffer' ? (<span><small>{format.toCurrency()}</small>{format.toPrice(coupon.discountValue, -1, false)}</span>) : format.toDiscount('discountRate', coupon.discountValue)}
        </h3>
        {
          coupon.orderFee ? (
            <h5>{i18n.t('cart.full', { money: format.toPrice(coupon.orderFee, 0, false) })}</h5>
          ) : coupon.type === 'item' ? (
            <h5>{i18n.t(`cart.${coupon.discountType}CouponItem`)}</h5>
          ) : coupon.type === 'cash' ? (
            <h5>{i18n.t('cart.discountFeeCouponItem')}</h5>
          ) : null
        }
      </div>
      <div className='coupon-item-c'>
        <h5>{coupon.couponName}</h5>
        <h6>
          {
            coupon.isForever ? i18n.t('cart.permanent') : format.toMonthDateYear(coupon.startTime) + ' - ' + format.toMonthDateYear(coupon.endTimeStamp - 1)
          }
        </h6>
        <h6>
          {
            coupon.isAllTime ? i18n.t('cart.allday') : i18n.t('cart.not_allday')
          }
        </h6>
      </div>
      <div className='coupon-item-r'>
        {
          isDelete ? <i className='iconfont icon-huabanbeifen32x delete-icon'></i> : <i className={['iconfont', coupon.isSelect ? 'icon-checked' : 'icon-circle'].join(' ')}></i>
        }
      </div>
    </div>
  )
}
export default CouponItem
